import { openPdf } from '@/shared/pdf-viewer/export';
import { analyticsService, AnalyticsEvent, AnalyticsTypes } from '@/shared/analytics/export';
import { SearchResultItem } from '@/core/search/model/search';
import { SearchResultTypeProvider } from '@/core/search/services/search-result-type-registry';

const filterValue = (item: SearchResultItem, key: string) =>
  item.filters?.find(f => f.key === key)?.value;

// PDF results in global search: open in the in-app viewer and the analytics payloads.
// Search documents do not carry the parent article headline, so `title` is the PDF title;
// `id` is the parent article externalId and `pdfUrl` identifies the document.
export const pdfSearchResultType: SearchResultTypeProvider = {
  async analyticsObject(item, actionType) {
    return {
      type: AnalyticsTypes.PDF,
      actionType,
      uri: item.uri,
      title: item.title,
      id: filterValue(item, 'externalId'),
      pdfUrl: filterValue(item, 'pdfUrl'),
    };
  },
  canOpen: item => !!filterValue(item, 'pdfUrl'),
  open(item, { subject, sessionId }) {
    const pdfUrl = filterValue(item, 'pdfUrl');
    if (!pdfUrl) return;
    openPdf(pdfUrl);
    analyticsService.recordAnalyticsEvent(AnalyticsEvent.ARTICLE_PDF_VIEWED, {
      subject,
      object: {
        type: AnalyticsTypes.ARTICLE,
        id: filterValue(item, 'externalId'),
        title: item.title,
        pdfUrl,
      },
      session: { id: sessionId },
    });
  },
};
